export * from './menu';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/menu/index.js
// module id = 874
// module chunks = 3